import { HTMLProps, PropsWithChildren, ReactNode } from 'react';

import clsx from 'clsx';

export enum InfoItemStyles {
  MAIN = 'main',
  DAYS = 'days',
}

type ForecastInfoItemProps = PropsWithChildren<
  HTMLProps<HTMLElement> & {
    icon: ReactNode;
    subIcon?: ReactNode;
    styleType: InfoItemStyles;
  }
>;

const ForecastInfoItem = ({ icon, subIcon, className, children, styleType }: ForecastInfoItemProps) => (
  <div
    className={clsx(
      'flex w-fit shrink-0 items-center',
      className,
      styleType === InfoItemStyles.MAIN ? 'text-grey-800 dark:text-white' : 'text-blue-grey-500'
    )}
  >
    <div className={clsx('w-8 flex-none lg:w-9', styleType === InfoItemStyles.DAYS && 'lg:hidden')}>{icon}</div>
    <div>
      <span
        className={clsx(
          'flex items-center text-sm font-medium text-grey-900 lg:text-base xl:text-lg',
          styleType === InfoItemStyles.MAIN && 'dark:text-white lg:font-normal'
        )}
      >
        {children}
        {subIcon}
      </span>
    </div>
  </div>
);

export default ForecastInfoItem;
